import { render } from "./BoxShadow.vue?vue&type=template&id=7cf19150&scoped=true"
import script from "./BoxShadow.vue?vue&type=script&lang=ts"
export * from "./BoxShadow.vue?vue&type=script&lang=ts"

import "./BoxShadow.vue?vue&type=style&index=0&id=7cf19150&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cf19150"

export default script